import type {
  GetListReportRequest,
  GetListResponseOfReportSimpleResponse,
} from 'src/api/ProactApiClient';
import {reportApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const reportApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getReportList: builder.query<
      GetListResponseOfReportSimpleResponse,
      GetListReportRequest
    >({
      queryFn: clientQuery(request => reportApiClient.listReports(request)),
      providesTags: ['Reports'],
    }),
    getReportEmbeddedUrl: builder.query<string, string>({
      queryFn: clientQuery(dashboardId =>
        reportApiClient.getEmbeddedUrl(dashboardId)
      ),
      providesTags: ['Reports'],
    }),
  }),
});

export const {useGetReportListQuery, useLazyGetReportEmbeddedUrlQuery} =
  reportApi;
